import { ConnectionEventListener } from '#/eventListeners/connectionEvents';
import { JoinEventListener } from '#/eventListeners/join';
import { PartEventListener } from '#/eventListeners/part'; 
import { KickEventListener } from '#/eventListeners/kick';
import { QuitEventListener } from '#/eventListeners/quit';
import { ChannelListEventListener } from '#/eventListeners/channelList';
import { PrivMsgEventListener } from '#/eventListeners/privmsg';
import { NoticeEventListener } from '#/eventListeners/notice';
import { ActionEventListener } from '#/eventListeners/action';
import { ModeEventListener } from '#/eventListeners/mode';
import { TopicEventListener } from '#/eventListeners/topic';
import { IrcErrorEventListener } from '#/eventListeners/ircError';
import { MotdEventListener } from '#/eventListeners/motd';
import { WhoisEventListener } from '#/eventListeners/whois';
import { NickEventListener } from '#/eventListeners/nick';
import { UserListEventListener } from '#/eventListeners/userlist';
import { AwayEventListener } from '#/eventListeners/away';
import { ChannelInfoEventListener } from '#/eventListeners/channelInfo';
import { InviteEventListener } from '#/eventListeners/invite';

export class EventManager {
    private connectionHandler: any;
    private eventListeners: any[] = [];

    constructor(connectionHandler: any) {
        this.connectionHandler = connectionHandler;
        this.initListeners();
    }

    private initListeners(): void {
        this.eventListeners.push(new ConnectionEventListener(this.connectionHandler));
        this.eventListeners.push(new JoinEventListener(this.connectionHandler));
        this.eventListeners.push(new PartEventListener(this.connectionHandler));
        this.eventListeners.push(new KickEventListener(this.connectionHandler));
        this.eventListeners.push(new QuitEventListener(this.connectionHandler));
        this.eventListeners.push(new ChannelListEventListener(this.connectionHandler));
        this.eventListeners.push(new ChannelInfoEventListener(this.connectionHandler));
        this.eventListeners.push(new PrivMsgEventListener(this.connectionHandler));
        this.eventListeners.push(new NoticeEventListener(this.connectionHandler));
        this.eventListeners.push(new ActionEventListener(this.connectionHandler));
        this.eventListeners.push(new ModeEventListener(this.connectionHandler));
        this.eventListeners.push(new TopicEventListener(this.connectionHandler));
        this.eventListeners.push(new IrcErrorEventListener(this.connectionHandler));
        this.eventListeners.push(new MotdEventListener(this.connectionHandler));
        this.eventListeners.push(new WhoisEventListener(this.connectionHandler));
        this.eventListeners.push(new NickEventListener(this.connectionHandler));
        this.eventListeners.push(new UserListEventListener(this.connectionHandler));
        this.eventListeners.push(new InviteEventListener(this.connectionHandler));

        // TODO:
        this.eventListeners.push(new AwayEventListener(this.connectionHandler));

    }
}